import { render, staticRenderFns } from "./full-slot.vue?vue&type=template&id=5e5fdcf7&"
import script from "./full-slot.vue?vue&type=script&lang=js&"
export * from "./full-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5fdcf7')) {
      api.createRecord('5e5fdcf7', component.options)
    } else {
      api.reload('5e5fdcf7', component.options)
    }
    module.hot.accept("./full-slot.vue?vue&type=template&id=5e5fdcf7&", function () {
      api.rerender('5e5fdcf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/full-slot.vue"
export default component.exports